import * as React from "react";
const SvgChevronUp20Px = (props) =>
  React.createElement(
    "svg",
    Object.assign(
      {
        xmlns: "http://www.w3.org/2000/svg",
        width: 10,
        height: 6,
        fill: "black",
        viewBox: "0 0 10 6"
      },
      props
    ),
    React.createElement("path", {
      fill: "current",
      fillRule: "evenodd",
      d: "M5 .438.365 6h9.27L5 .438Z",
      clipRule: "evenodd"
    })
  );
export default SvgChevronUp20Px;
